/**
 * League invite links — Phase D2 (server authority for join).
 */
import { auth } from '../auth/firebaseAuth';

function getFunctionsBaseUrl() {
  const base = process.env.REACT_APP_CLOUD_FUNCTIONS_URL;
  if (base) return base.replace(/\/$/, '');
  const projectId = process.env.REACT_APP_PROJECT_ID;
  if (!projectId) return null;
  const region = process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';
  if (process.env.REACT_APP_USE_EMULATORS === 'true') {
    const emulatorPort = process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5011';
    return `http://127.0.0.1:${emulatorPort}/${projectId}/${region}`;
  }
  return `https://${region}-${projectId}.cloudfunctions.net`;
}

async function getIdToken() {
  const user = auth.currentUser;
  if (!user) throw new Error('Sign in to continue.');
  return user.getIdToken();
}

export async function previewGroupInviteLink(token) {
  const base = getFunctionsBaseUrl();
  if (!base) throw new Error('Cloud Functions URL not configured.');
  const res = await fetch(
    `${base}/preview_group_invite_link?token=${encodeURIComponent(token)}`,
    { method: 'GET' },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Preview failed (${res.status})`);
  return data.preview;
}

export async function createGroupInviteLink(groupId) {
  const base = getFunctionsBaseUrl();
  if (!base) throw new Error('Cloud Functions URL not configured.');
  const idToken = await getIdToken();
  const res = await fetch(`${base}/create_group_invite_link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ groupId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Could not create link (${res.status})`);
  return data;
}

export async function joinGroupViaLink(token) {
  const base = getFunctionsBaseUrl();
  if (!base) throw new Error('Cloud Functions URL not configured.');
  const idToken = await getIdToken();
  const res = await fetch(`${base}/join_group_via_link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ token }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Could not join (${res.status})`);
  return data;
}

export async function revokeGroupInviteLink(token) {
  const base = getFunctionsBaseUrl();
  if (!base) throw new Error('Cloud Functions URL not configured.');
  const idToken = await getIdToken();
  const res = await fetch(`${base}/revoke_group_invite_link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ token }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Could not revoke link (${res.status})`);
  return data;
}
